module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('information-popup', {
    attrs: {
      "modal-id": "inscriptionGuidelinesPopup",
      "info": _vm.info
    }
  }, [_c('template', {
    slot: "header"
  }, [_vm._v("Inscription Guidelines")]), _vm._v(" "), _vm._t("default", [_c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n            Your personalized message can be engraved with up to " + _vm._s(_vm.info.max_chars) + " characters per line, including blank spaces.\n            A character is any letter, number, symbol or punctuation mark found on a standard English keyboard.\n            All text will automatically be centered and engraved in UPPERCASE letters.\n            Discriminatory, political, offensive or unsuitable messages as determined by Prosper ISD will be declined.\n            Prosper ISD reserves the right to decline inscriptions for any reason.\n            Should your inscription require revision, you will be contacted for assistance in submitting an alternative inscription.\n        ")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58fbbe6f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/InscriptionGuidelines.vue
// module id = 7JtF
// module chunks = 1